/* eslint-disable @typescript-eslint/naming-convention */

import { IFormItemProps } from '@/components';
import { HomeDataManagerType, HomeDataStyle } from '@/const/promotion';
import { ImageRatio } from '@/const/richMedia';
import { fetchSpaceOptions } from '@/pages/space/fetch/fetchSpace-config';

import { ManageSelectOptions, ManageStyleOptions } from '../../config';
import { validateStories } from '../validate';

export const commonFormCard = (formType: HomeDataManagerType): IFormItemProps[] => [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'managerType',
    label: '配置类型',
    render: 'debounceSelect',
    rules: [{ required: true, message: '请选择配置类型' }],
    uiOptions: {
      options: ManageSelectOptions,
    },
  },
  {
    props: 'style',
    label: '样式类型',
    render: 'hidden',
    useFormData: true,
    uiOptions: {
      useFormData: true,
      fetchOptions: async () => ({
        list: ManageStyleOptions,
      }),
    },
  },
  {
    props: 'stories',
    label: '选择故事',
    render: 'customStories',
    rules: [
      { required: true, message: '请选择故事' },
      { validator: e => validateStories(e, formType === HomeDataManagerType.HOMEDATAMANAGERTYPE_BANNER) },
    ],
    uiOptions: {},
  },
];

export const formCardRankCover: IFormItemProps[] = [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'managerType',
    label: '配置类型',
    render: 'debounceSelect',
    rules: [{ required: true, message: '请选择配置类型' }],
    uiOptions: {
      options: ManageSelectOptions,
    },
  },
  {
    props: 'style',
    label: '样式类型',
    render: 'hidden',
    useFormData: true,
    uiOptions: {
      useFormData: true,
      fetchOptions: async () => ({
        list: ManageStyleOptions,
      }),
    },
  },
  {
    props: 'name',
    label: '排行榜标题',
    render: 'input',
  },
  {
    props: 'space',
    label: '排行榜分类',
    render: 'debounceSelect',
    uiOptions: {
      openUpdateOptions: true,
      hasDefault: true,
      valueType: 'object',
      fetchOptions: fetchSpaceOptions,
    },
    rules: [
      { required: true, message: '请选择排行榜分类' },
    ],
  },
  {
    props: 'topNum',
    label: '排行榜展示数量',
    render: 'number',
    rules: [],
    uiOptions: {
      min: 1,
    },
  },
  {
    props: 'bgImage',
    label: '封面图',
    render: 'pic',
    className: 'row-2',
    uiOptions: {
      width: 240,
      height: 180,
      isShowRichMedia: true,
      maxCount: 1,
      limit: { ratio: ImageRatio['4:3'] },
    },
  },
];

export const formCollection: IFormItemProps[] = [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'managerType',
    label: '配置类型',
    render: 'debounceSelect',
    rules: [{ required: true, message: '请选择配置类型' }],
    uiOptions: {
      options: ManageSelectOptions,
    },
  },
  {
    props: 'space',
    label: '合集类型',
    render: 'debounceSelect',
    uiOptions: {
      openUpdateOptions: true,
      hasDefault: true,
      valueType: 'object',
      fetchOptions: fetchSpaceOptions,
    },
    rules: [
      { required: true, message: '请选择合集' },
    ],
  },
  {
    props: 'style',
    label: '样式类型',
    render: 'hidden',
    useFormData: true,
    uiOptions: {
      useFormData: true,
      fetchOptions: async () => ({
        list: ManageStyleOptions,
      }),
    },
  },
  {
    props: 'name',
    label: '标题',
    render: 'input',
    labelSetting: {
      tipText: '优先级高于选择的合集名称',
    },
  },
  {
    props: 'stories',
    label: '选择故事',
    render: 'customStories',
    rules: [
      { required: true, message: '请选择故事' },
      { validator: e => validateStories(e, false) },
    ],
    uiOptions: {},
  },
];

export const formMultiCollection: IFormItemProps[] = [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'managerType',
    label: '配置类型',
    render: 'debounceSelect',
    rules: [{ required: true, message: '请选择配置类型' }],
    uiOptions: {
      options: ManageSelectOptions,
    },
  },
  {
    props: 'multiCollection',
    label: '榜单配置',
    render: 'customMultiCollection',
  },
];

export const formOfficialGroup: IFormItemProps[] = [
  {
    props: 'id',
    label: '唯一ID：（id）',
    render: 'hidden',
    uiOptions: {
      disabled: true,
    },
  },
  {
    props: 'managerType',
    label: '配置类型',
    render: 'debounceSelect',
    rules: [{ required: true, message: '请选择配置类型' }],
    uiOptions: {
      options: ManageSelectOptions,
    },
  },
  {
    props: 'officialActivity',
    label: '官方活动配置',
    render: 'customOfficialActivity',
  },
];

export const formConfig: { [key: string]: IFormItemProps[] } = {
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_BANNER]:
    commonFormCard(HomeDataManagerType.HOMEDATAMANAGERTYPE_BANNER),
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_RANK]:
    formCardRankCover,
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_RECOMMEND]:
    commonFormCard(HomeDataManagerType.HOMEDATAMANAGERTYPE_RECOMMEND),
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_COLLECTION]:
    formCollection,
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_MULTI_COLLECTION]:
    formMultiCollection,
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_OFFICIALGROUP]:
    formOfficialGroup,
};

export const formStyle: { [key: string]: HomeDataStyle } = {
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_BANNER]: HomeDataStyle.HOMEDATASTYLE_BANNER,
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_RECOMMEND]: HomeDataStyle.HOMEDATASTYLE_RECOMMEND_STORY,
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_COLLECTION]: HomeDataStyle.HOMEDATASTYLE_HORIZONTAL_SLIDE,
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_RANK]: HomeDataStyle.HOMEDATASTYLE_VERTICAL_SLIDE,
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_MULTI_COLLECTION]: HomeDataStyle.HOMEDATASTYLE_MULTIPLE_COLLECTION,
  [HomeDataManagerType.HOMEDATAMANAGERTYPE_OFFICIALGROUP]: HomeDataStyle.HOMEDATASTYLE_OFFICIALGROUP,
};
